import { z } from 'zod';

export const entityTypeSchema = z.object({
  sectorId: z.number().int().positive(),
  code: z.string().min(2).max(80).regex(/^[a-z0-9-]+$/, 'Code must be lowercase and use only letters, numbers, and dashes'),
  name: z.string().min(1).max(120),
  category: z.enum(['user', 'device', 'infrastructure', 'service']),
  scope: z.enum(['company', 'branch']).default('branch'),
  icon: z.string().max(32).optional().nullable(),
  sortOrder: z.number().int().min(0).optional(),
  isActive: z.boolean().optional(),
  allowMultiple: z.boolean().optional(),
  isRequired: z.boolean().optional(),
});


